import moment from 'moment';
import { TODAY, getNextDaysFrom, getFormatedDate } from './date-utils';

const fakeStates = [
  'Alabama',
  'Alaska',
  'Arizona',
  'Arkansas',
  'California',
  'Colorado',
];

const DATE_FORMAT = 'YYYY/MM/DD HH:mm:ss';

export const generateFakeData = ({ numberOfItems = 5 } = {}) => {
  const daysArr = getNextDaysFrom({ daysToAdd: numberOfItems });

  const fakeEvents = daysArr.map((day, index) => {
    const fakeEvent = {
      id: index + 1,
      name: `test-${index}`,
      lat: `test-lat-${index}`,
      lng: `test-lng-${index}`,
      description: `test-description-${index}`,
      startAt: day,
      endAt: '2020:06:04 12:06:24',
      link: 'https://www.instagram.com',
      // state: 'Arkansas',
      state: fakeStates[index],
    };
    return fakeEvent;
  });
  return fakeEvents;
};

export const filterEventsByToday = (events) => {
  const filteredEvents = events.filter((event) => {
    const formatedEventDate = getFormatedDate({ date: event.startAt });
    const formatedFilterDay = getFormatedDate({ date: TODAY });
    return formatedEventDate === formatedFilterDay;
  });
  return filteredEvents;
};

export const filterEventsByDate = ({ events, filterDate: date }) => {
  const filterDate = moment(date, DATE_FORMAT);
  const filteredEvents = events.filter((event) => {
    const eventStartDate = moment(event.startAt, DATE_FORMAT);
    const eventEndDate = moment(event.endAt, DATE_FORMAT);
    return filterDate.isBetween(eventStartDate, eventEndDate);
  });
  return filteredEvents.length > 0 ? filteredEvents : [];
};

const getEventsToUse = ({ useFakeData, initEvents }) => {
  return useFakeData ? generateFakeData() : initEvents;
};

const getFilteredEventsBySelectedCalendarDate = ({
  eventsList,
  selectedDateByCalendar,
}) => {
  const formatedSelectedDateByCalendar = getFormatedDate({
    date: selectedDateByCalendar,
    format: 'YYYY/MM/DD HH:mm:ss',
  });
  const filteredEventsByCalendarDate = filterEventsByDate({
    events: eventsList,
    filterDate: formatedSelectedDateByCalendar,
  });

  return filteredEventsByCalendarDate;
};

const filterEventsByState = ({ eventsArr, stateSelected }) => {
  const eventsArrFiltered =
    stateSelected.length > 0
      ? eventsArr.filter((event) => {
          return event.state === stateSelected;
        })
      : [];
  return eventsArrFiltered;
};

const getFilteredEvenstByDate = ({
  initialEvents,
  weekToUse,
  selectedDateIndex,
}) => {
  const filteredEventsByDate =
    !!initialEvents && initialEvents.length > 0
      ? filterEventsByDate({
          events: initialEvents,
          filterDate: weekToUse[selectedDateIndex].day,
        })
      : [];
  return filteredEventsByDate;
};

export const getEventsToShow = ({
  useFakeData = false,
  initEvents,
  selectedDateByCalendar,
  selectedSuggestedState,
  weekToUse,
  selectedDateIndex,
}) => {
  const eventsToUse = getEventsToUse({ useFakeData, initEvents });

  const filteredEventsByCalendarDate = getFilteredEventsBySelectedCalendarDate({
    eventsList: eventsToUse,
    selectedDateByCalendar,
  });

  const filteredEventsToUse =
    filteredEventsByCalendarDate.length > 0 ? filteredEventsByCalendarDate : [];

  const filteredEventsByState = filterEventsByState({
    eventsArr: filteredEventsToUse,
    stateSelected: selectedSuggestedState,
  });

  // TODO: REFACTOR THIS
  let filteredEvents =
    filteredEventsByState.length > 0 && selectedSuggestedState.length > 0
      ? getFilteredEvenstByDate({
          initialEvents: filteredEventsByState,
          weekToUse,
          selectedDateIndex,
        })
      : filteredEventsToUse;

  // Clear list if doesnt find events in that date in that state
  if (selectedSuggestedState.length > 0 && filteredEventsByState.length === 0) {
    filteredEvents = [];
  }

  const eventsToShow =
    !!filteredEvents && filteredEvents.length > 0 ? filteredEvents : [];
  return eventsToShow;
};

export const getCurrentCalendarValue = ({ selectedDateByCalendar }) => {
  return new Date(selectedDateByCalendar);
};

export const getSortedEventsByDate = (initEvents) => {
  const formatedEvents = initEvents.map((event) => {
    return {
      ...event,
      startAt: getFormatedDate({
        date: event.startAt,
        format: 'YYYY/MM/DD HH:mm:ss',
      }),
      endAt: getFormatedDate({
        date: event.endAt,
        format: 'YYYY/MM/DD HH:mm:ss',
      }),
    };
  });
  const sortedArray = formatedEvents.sort((a, b) => {
    return moment(b.startAt).diff(a.startAt);
  });
  return sortedArray;
};
